import React from 'react';
import {Typography, Button} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import {CheckCircle} from '@mui/icons-material';
import {styled} from '@mui/material/styles';
import {useNavigate} from 'react-router-dom';

export const ContainerStyled = styled('div')({
    padding: '40px'
});

export const CheckCircleStyled = styled(CheckCircle)({
    width: 66,
    height: 66,
    marginBottom: 30,
    color: 'black'
});

export const TitleStyled = styled(Typography)({
    marginBottom: '30px',
    fontSize: '24px',
    fontWeight: 600
});

export const TextStyled = styled(Typography)({
    fontSize: '14px',
    marginBottom: '20px'
});

export const ButtonStyled = styled(Button)({
    width: '100%',
    marginTop: '10px',
    backgroundColor: 'black'
});

export const ActionBarStyled = styled('div')({
    display: 'flex',
    marginTop: 30,
    alignItems: 'center',
    justifyContent: 'center'
});

interface AnalysisStartedProps {
    onClose?: () => void;
    experimentId: string | undefined;
    dontShowAgain: boolean;
    onDontShowAgainChange: (checked: boolean) => void;
}

export const AnalysisStarted: React.FC<AnalysisStartedProps> = ({experimentId, onClose, dontShowAgain, onDontShowAgainChange}) => {
    const navigate = useNavigate();

    const onHandleClose = () => {
        if (onClose) {
            onClose();
        }
        navigate('/');
    };

    return (
        <ContainerStyled>
            <CheckCircleStyled />
            <TitleStyled>Analysis has started</TitleStyled>
            <TextStyled>
                Your analysis has started and may take up to 24 hours to complete. You can check the experiment dashboard for progress and
                results.
            </TextStyled>
            <TextStyled sx={{fontWeight: 600}}>
                Note: Once initial analysis of your samples is complete, additional analysis may be processed faster.
            </TextStyled>

            <ButtonStyled onClick={() => navigate(`/experiment/${experimentId}`)} variant="contained">
                Return to Experiment Details
            </ButtonStyled>
            <ButtonStyled onClick={onHandleClose} variant="outlined" sx={{background: 'white'}}>
                Go to the main Dashboard
            </ButtonStyled>
            <ActionBarStyled>
                <Checkbox
                    inputProps={{'aria-label': "Don't show this again"}}
                    checked={dontShowAgain}
                    onChange={event => onDontShowAgainChange(event.target.checked)}
                />
                Don’t show this again
            </ActionBarStyled>
        </ContainerStyled>
    );
};
